// Add new videos to this list to publish them.
// `id` is the provider's video ID.
// `provider` = "youtube" (default) or "vimeo".
const VIDEOS = [
  {
    id: "984875250",
    provider: "vimeo",
    title: "How ecoHeatwave delivers radiant warmth.",
    caption:
      "A short film from Lovell explaining how the ecoHeatwave panels installed in the Lovell Tomorrow Home work.",
    date: "October 2024",
  },
  {
    id: "ifHKWmm2MKs",
    provider: "youtube",
    title: "ecoHeatwave & the Lovell Tomorrow Home.",
    caption:
      "John Johnson walks through the Lovell Tomorrow Home — a working example of ecoHeatwave delivering low-carbon heating in a modern new-build.",
    date: "November 2024",
  },
];

function embedUrl(video) {
  if (video.provider === "vimeo") {
    return `https://player.vimeo.com/video/${video.id}?title=0&byline=0&portrait=0`;
  }
  return `https://www.youtube-nocookie.com/embed/${video.id}?rel=0&modestbranding=1`;
}

export default function VideoGallery() {
  if (VIDEOS.length === 0) return null;

  return (
    <section id="videos" data-testid="video-section" className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeader />
        <VideoGrid videos={VIDEOS} />
      </div>
    </section>
  );
}

function SectionHeader() {
  return (
    <div className="max-w-4xl mb-14 md:mb-16">
      <div className="overline mb-6">Watch</div>
      <h2
        data-testid="video-headline"
        className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-[-0.02em] leading-[1.05] text-ecoh-ink"
      >
        See ecoHeatwave in motion.
      </h2>
      <p className="mt-6 max-w-2xl text-ecoh-ink/70 text-lg md:text-xl font-light leading-snug">
        Short films exploring how the system works, how it looks and how it
        integrates on real projects.
      </p>
    </div>
  );
}

function VideoGrid({ videos }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
      {videos.map((v) => (
        <VideoCard key={v.id} video={v} />
      ))}
    </div>
  );
}

function VideoCard({ video }) {
  return (
    <div
      data-testid={`video-card-${video.id}`}
      className="rounded-2xl overflow-hidden bg-ecoh-ink ring-1 ring-ecoh-ink/10"
    >
      <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
        <iframe
          src={embedUrl(video)}
          title={video.title}
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="absolute inset-0 w-full h-full"
        />
      </div>
      {(video.title || video.caption || video.date) && (
        <div className="bg-white p-6">
          {video.date && (
            <div className="text-[10px] tracking-[0.22em] uppercase text-ecoh-accent mb-2">
              {video.date}
            </div>
          )}
          {video.title && (
            <h3 className="font-display text-base md:text-lg font-light tracking-tight text-ecoh-ink">
              {video.title}
            </h3>
          )}
          {video.caption && (
            <p className="mt-2 text-ecoh-muted text-sm font-light leading-relaxed">
              {video.caption}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
